import React from 'react';
import { CATS, TC } from '../data/constants';
import { exportComparePdf } from '../utils/comparePdf';

export function CompareModal({ theme, isMobile, compareList, setCompareList, setShowCompare, places, onShareToast }) {
  const handleShare = async () => {
    const items = compareList.map(id=>places.find(p=>p.id===id)).filter(Boolean);
    if (!items.length) return;
    const slugs = items.map(p => p.slug || p.id).join(',');
    const url = `${window.location.origin}/?compare=${slugs}`;
    try { await navigator.clipboard.writeText(url); } catch(e) {}
    if (navigator.share) {
      try { await navigator.share({ title:'OkulMap Karşılaştırma', text:`${items.length} okulu karşılaştır`, url }); } catch(e) {}
    }
    if (onShareToast) onShareToast('🔗 Karşılaştırma linki kopyalandı');
  };
  const C = (k) => {
    const d = theme === 'dark';
    const m = {
      surf:d?'#141924':'#FFFAF5',
      bord:d?'rgba(255,255,255,0.07)':'rgba(139,92,246,0.10)',
      txt:d?'#ffffff':'#1E1048',
      txt2:d?'rgba(255,255,255,0.5)':'#4B3D7A',
      txt3:d?'rgba(255,255,255,0.25)':'#9B8FBD',
    };
    return m[k]||'';
  };
  const items = compareList.map(id=>places.find(p=>p.id===id)).filter(Boolean);
  // Helper: check if features array contains keyword (case-insensitive, Turkish-aware)
  const hasFeat = (p, ...kws) => {
    const norm = s => (s||'').replace(/İ/g,'i').replace(/I/g,'i').replace(/ı/g,'i').replace(/Ş/g,'s').replace(/ş/g,'s').replace(/Ğ/g,'g').replace(/ğ/g,'g').replace(/Ü/g,'u').replace(/ü/g,'u').replace(/Ö/g,'o').replace(/ö/g,'o').replace(/Ç/g,'c').replace(/ç/g,'c').toLowerCase();
    return kws.some(kw => p.features.some(f => norm(f).includes(norm(kw))));
  };
  const tick = (v) => v ? <span style={{color:'#4ECDC4',fontSize:15}}>✓</span> : <span style={{color:'rgba(255,255,255,0.18)',fontSize:14}}>—</span>;

  const ROWS = [
    // ── GENEL ──
    {section:'GENEL BİLGİLER'},
    {label:'Puan',      fn:p=><><span style={{color:'#FFE66D'}}>★</span> {p.rating} <span style={{color:'rgba(255,255,255,0.3)',fontSize:10}}>({p.reviews} yorum)</span></>},
    {label:'Aidat',     fn:p=>p.price},
    {label:'Yaş Grubu', fn:p=>p.age+' yaş'},
    {label:'Kapasite',      fn:p=>p.capacity ? p.capacity+' kişi' : '—'},
    {label:'Sınıf Mevcudu',    fn:p=>p.avgClassSize ? p.avgClassSize+' kişi' : '—'},
    {label:'Öğretmen/Çocuk',   fn:p=>p.teacherChildRatio || '—'},
    {label:'Doluluk',       fn:p=>{ const pct=Math.round((p.capacity>0?p.filled/p.capacity:0)*100); const col=pct>80?'#FF6B6B':pct>60?'#FFE66D':'#4ECDC4'; return <span style={{color:col}}>{pct}%</span>; }},
    {label:'Çalışma',   fn:p=>p.hours},
    {label:'Durum',     fn:p=>p.open?<span style={{color:'#4ECDC4'}}>Açık</span>:<span style={{color:'#888'}}>Kapalı</span>},
    {label:'Adres',     fn:p=>p.city||(p.address||'—')},
    // ── EĞİTİM ──
    {section:'EĞİTİM'},
    {label:'Yabancı Dil',fn:p=>{ const langs=[]; if(hasFeat(p,'ingilizce','english')) langs.push('🇬🇧'); if(hasFeat(p,'almanca','german')) langs.push('🇩🇪'); if(hasFeat(p,'fransızca','french')) langs.push('🇫🇷'); if(hasFeat(p,'ispanyolca','spanish')) langs.push('🇪🇸'); if(hasFeat(p,'arapca','arapça','arabic')) langs.push('🇸🇦'); return langs.length ? <span style={{fontSize:15}}>{langs.join(' ')}</span> : <span style={{color:'rgba(255,255,255,0.2)'}}>—</span>; }},
    {label:'Montessori', fn:p=>tick(hasFeat(p,'montessori'))},
    {label:'Reggio',     fn:p=>tick(hasFeat(p,'reggio'))},
    {label:'Waldorf',    fn:p=>tick(hasFeat(p,'waldorf'))},
    {label:'STEM/STEAM', fn:p=>tick(hasFeat(p,'stem','steam','kodlama','robotik'))},
    {label:'Sanat/Müzik',fn:p=>tick(hasFeat(p,'sanat','müzik','muzik','dans','resim'))},
    {label:'Satranç',    fn:p=>tick(hasFeat(p,'satranç'))},
    // ── TESİS ──
    {section:'TESİS & ORTAM'},
    {label:'Bahçe',      fn:p=>tick(hasFeat(p,'bahçe','bahce','dış alan','doğa'))},
    {label:'Doğa Alanı', fn:p=>tick(hasFeat(p,'doğa','orman','park','açık hava'))},
    {label:'Yüzme Havuzu',fn:p=>tick(hasFeat(p,'havuz','yüzme'))},
    {label:'Spor Salonu', fn:p=>tick(hasFeat(p,'spor salonu','jimnastik','gym'))},
    {label:'Yemekhane',  fn:p=>tick(hasFeat(p,'yemek','öğle yemeği','kantin','yemekhane'))},
    {label:'Servis',     fn:p=>tick(hasFeat(p,'servis','taşıma','araç'))},
    {label:'Kamera',     fn:p=>tick(hasFeat(p,'kamera','güvenlik kamerası'))},
    // ── DİJİTAL ──
    {section:'DİJİTAL'},
    {label:'OkulBot',    fn:p=>p.okulbot?<span style={{color:'#A8DAFF'}}>✓</span>:<span style={{color:'rgba(255,255,255,0.2)'}}>—</span>},
    {label:'Doğrulanmış',fn:p=>p.is_verified?<span style={{color:'#4ECDC4'}}>✓</span>:<span style={{color:'rgba(255,255,255,0.2)'}}>—</span>},
  ];

  const labelW = isMobile ? 72 : 90;
  const featLabelW = isMobile ? 90 : 120;

  const sectionTitle = (t) => (
    <div style={{color:C('txt3'),fontSize:11,fontWeight:700,letterSpacing:'0.08em',marginBottom:isMobile?8:10}}>{t}</div>
  );

  const barCard = (children) => (
    <div style={{background:'rgba(255,255,255,0.02)',borderRadius:12,border:'1px solid '+C('bord'),padding:isMobile?12:14,marginBottom:16}}>
      {children}
    </div>
  );

  return (
    <div style={{
        position:'fixed',inset:0,zIndex:1100,display:'flex',backdropFilter:'blur(8px)',background:'rgba(0,0,0,0.8)',
        alignItems: isMobile ? 'stretch' : 'center',
        justifyContent: isMobile ? 'flex-end' : 'center',
        flexDirection: isMobile ? 'column' : 'row',
      }}
      onClick={()=>setShowCompare(false)}>
      <div style={{
          background:C('surf'),
          borderRadius: isMobile ? '20px 20px 0 0' : 20,
          width: isMobile ? '100%' : 'min(900px,95vw)',
          maxHeight: isMobile ? '92dvh' : '88vh',
          overflowY:'auto',
          padding: isMobile ? '0 0 calc(24px + env(safe-area-inset-bottom,0px))' : '28px 28px 32px',
          boxShadow:'0 24px 64px rgba(0,0,0,0.5)',
          border:'1px solid '+C('bord'),
          animation:'fadeIn 0.2s ease',
        }}
        onClick={e=>e.stopPropagation()}>

        {/* Mobil drag handle */}
        {isMobile && <div style={{width:40,height:4,borderRadius:2,background:'rgba(255,255,255,0.15)',margin:'12px auto 0'}}/>}

        {/* Başlık */}
        <div style={{
            display:'flex',alignItems:'center',justifyContent:'space-between',
            padding: isMobile ? '16px 16px 12px' : '0 0 20px',
            position: isMobile ? 'sticky' : 'static',
            top:0, background:C('surf'), zIndex:2,
            borderBottom: isMobile ? '1px solid '+C('bord') : 'none',
          }}>
          <div style={{fontFamily:'Syne,sans-serif',fontSize:isMobile?17:20,fontWeight:800,color:C('txt')}}>⚖️ Karşılaştır</div>
          <div style={{display:'flex',gap:6,alignItems:'center'}}>
            {compareList.length>0 && (
              <>
                <button onClick={()=>exportComparePdf({ items })} title="PDF olarak indir"
                  style={{height:32,padding:'0 12px',borderRadius:8,background:'rgba(255,255,255,0.06)',border:'1px solid '+C('bord'),color:C('txt'),cursor:'pointer',fontSize:12,fontWeight:700,fontFamily:'DM Sans,sans-serif',display:'flex',alignItems:'center',gap:5}}>
                  📄 PDF
                </button>
                <button onClick={handleShare} title="Karşılaştırma linkini paylaş"
                  style={{height:32,padding:'0 12px',borderRadius:8,background:'rgba(168,218,255,0.15)',border:'1px solid rgba(168,218,255,0.4)',color:'#A8DAFF',cursor:'pointer',fontSize:12,fontWeight:700,fontFamily:'DM Sans,sans-serif',display:'flex',alignItems:'center',gap:5}}>
                  🔗 Paylaş
                </button>
              </>
            )}
            <button onClick={()=>setShowCompare(false)} style={{width:32,height:32,borderRadius:8,background:'rgba(255,255,255,0.07)',border:'1px solid '+C('bord'),color:C('txt2'),cursor:'pointer',fontSize:14}}>✕</button>
          </div>
        </div>

        <div style={{padding: isMobile ? '16px 16px 0' : 0}}>
          {items.length===0 ? (
            <div style={{textAlign:'center',padding:'48px 0',color:C('txt2')}}>
              <div style={{fontSize:40,marginBottom:10}}>📋</div>
              Detay sayfasından "+ Karşılaştır" butonuna bas
            </div>
          ) : (
            <>
              {/* Kurum kartları */}
              <div style={{display:'flex',gap:8,marginBottom:16}}>
                {!isMobile && <div style={{width:labelW,flexShrink:0}}/>}
                {items.map(p=>{ const color=TC[p.type]; const cat=CATS.find(c=>c.id===p.type)||{}; return (
                  <div key={p.id} style={{flex:1,background:color+'12',border:'1px solid '+color+'40',borderRadius:12,padding:isMobile?10:12,position:'relative',textAlign:'center',minWidth:0}}>
                    <button onClick={e=>{e.stopPropagation();setCompareList(prev=>prev.filter(x=>x!==p.id));}}
                      style={{position:'absolute',top:6,right:6,width:18,height:18,borderRadius:'50%',background:'rgba(255,255,255,0.1)',border:'none',color:C('txt2'),fontSize:9,cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center'}}>✕</button>
                    <div style={{fontSize:isMobile?20:24,marginBottom:3}}>{cat.icon}</div>
                    <div style={{color:C('txt'),fontSize:isMobile?11:12,fontWeight:700,lineHeight:1.3,overflow:'hidden',textOverflow:'ellipsis',display:'-webkit-box',WebkitLineClamp:2,WebkitBoxOrient:'vertical'}}>{p.name}</div>
                    <div style={{color,fontSize:10,marginTop:3}}>★ {p.rating}</div>
                  </div>
                );})}
                {items.length<3 && (
                  <div style={{flex:1,background:'rgba(255,255,255,0.02)',border:'1px dashed rgba(255,255,255,0.1)',borderRadius:12,display:'flex',alignItems:'center',justifyContent:'center',minHeight:isMobile?70:80,color:C('txt3'),fontSize:24,cursor:'pointer',minWidth:0}}
                    onClick={()=>setShowCompare(false)}>+</div>
                )}
              </div>

              {/* Karşılaştırma tablosu */}
              <div style={{background:'rgba(255,255,255,0.02)',borderRadius:14,border:'1px solid '+C('bord'),overflow:'hidden',marginBottom:16}}>
                {ROWS.map((row,ri)=>{
                  if (row.section) {
                    return (
                      <div key={ri} style={{display:'flex',background:'rgba(255,255,255,0.03)',borderBottom:'1px solid '+C('bord')}}>
                        <div style={{padding:isMobile?'6px 10px':'7px 14px',fontSize:9,color:C('txt3'),fontWeight:700,letterSpacing:'0.09em',textTransform:'uppercase',flex:1}}>{row.section}</div>
                      </div>
                    );
                  }
                  const isLast = ri === ROWS.length - 1 || ROWS[ri+1]?.section;
                  return (
                    <div key={ri} style={{display:'flex',borderBottom:isLast?'none':'1px solid '+C('bord')}}>
                      <div style={{width:labelW,padding:isMobile?'9px 10px':'10px 14px',fontSize:isMobile?10:11,color:C('txt2'),fontWeight:600,flexShrink:0,borderRight:'1px solid '+C('bord'),display:'flex',alignItems:'center'}}>{row.label}</div>
                      {items.map((p,pi)=>(
                        <div key={pi} style={{flex:1,padding:isMobile?'9px 8px':'10px 12px',fontSize:isMobile?11:12,color:C('txt'),borderRight:pi<items.length-1?'1px solid '+C('bord'):'none',display:'flex',alignItems:'center',minWidth:0}}>{row.fn(p)}</div>
                      ))}
                      {items.length<3 && <div style={{flex:1}}/>}
                    </div>
                  );
                })}
              </div>

              {/* Ortak özellikler */}
              {items.length>=2 && (()=>{ const common=items[0].features.filter(f=>items.slice(1).every(p=>p.features.includes(f))); return (
                <div style={{marginBottom:16}}>
                  {sectionTitle('ORTAK ÖZELLİKLER')}
                  {common.length>0 ? (
                    <div style={{display:'flex',flexWrap:'wrap',gap:6}}>
                      {common.map(f=><span key={f} style={{background:'rgba(168,218,255,0.1)',border:'1px solid rgba(168,218,255,0.25)',borderRadius:8,padding:'4px 9px',fontSize:11,color:'#A8DAFF'}}>{f}</span>)}
                    </div>
                  ) : <div style={{color:C('txt3'),fontSize:12}}>Ortak özellik yok</div>}
                </div>
              );})()}

              {/* Fiyat barları */}
              {items.length>=2&&(()=>{
                const maxPrice=Math.max(...items.map(p=>p.priceNum));
                if(!maxPrice) return null;
                return (
                  <div style={{marginBottom:16}}>
                    {sectionTitle('FİYAT KARŞILAŞTIRMASI')}
                    {barCard(items.map(p=>{
                      const pct=p.priceNum>0?(p.priceNum/maxPrice)*100:0;
                      const col=TC[p.type]||'#A8DAFF';
                      return (
                        <div key={p.id} style={{marginBottom:10}}>
                          <div style={{display:'flex',justifyContent:'space-between',marginBottom:5}}>
                            <span style={{color:C('txt2'),fontSize:11,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap',maxWidth:'65%'}}>{p.name}</span>
                            <span style={{color:col,fontSize:11,fontWeight:700,flexShrink:0,marginLeft:8}}>{p.price}</span>
                          </div>
                          <div style={{height:6,background:'rgba(255,255,255,0.06)',borderRadius:3,overflow:'hidden'}}>
                            <div style={{height:'100%',width:pct+'%',background:'linear-gradient(90deg,'+col+'99,'+col+')',borderRadius:3,transition:'width 0.6s'}}/>
                          </div>
                        </div>
                      );
                    }))}
                  </div>
                );
              })()}

              {/* Puan barları */}
              <div style={{marginBottom:16}}>
                {sectionTitle('PUAN KARŞILAŞTIRMASI')}
                {barCard(items.map(p=>{
                  const pct=(p.rating/5)*100;
                  return (
                    <div key={p.id} style={{marginBottom:10}}>
                      <div style={{display:'flex',justifyContent:'space-between',marginBottom:5}}>
                        <span style={{color:C('txt2'),fontSize:11,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap',maxWidth:'65%'}}>{p.name}</span>
                        <span style={{color:'#FFE66D',fontSize:11,fontWeight:700,flexShrink:0,marginLeft:8}}>★ {p.rating}</span>
                      </div>
                      <div style={{height:6,background:'rgba(255,255,255,0.06)',borderRadius:3,overflow:'hidden'}}>
                        <div style={{height:'100%',width:pct+'%',background:'linear-gradient(90deg,#FFE66D99,#FFE66D)',borderRadius:3,transition:'width 0.6s'}}/>
                      </div>
                    </div>
                  );
                }))}
              </div>

              {/* Özellik matrisi */}
              {items.length>=2&&(()=>{
                const allFeatures=[...new Set(items.flatMap(p=>p.features))];
                if(!allFeatures.length) return null;
                return (
                  <div style={{marginBottom:8}}>
                    {sectionTitle('ÖZELLİK MATRİSİ')}
                    <div style={{background:'rgba(255,255,255,0.02)',borderRadius:12,border:'1px solid '+C('bord'),overflow:'hidden'}}>
                      {allFeatures.map((f,fi)=>(
                        <div key={f} style={{display:'flex',borderBottom:fi<allFeatures.length-1?'1px solid '+C('bord'):'none'}}>
                          <div style={{width:featLabelW,padding:isMobile?'8px 10px':'9px 14px',fontSize:isMobile?10:11,color:C('txt2'),flexShrink:0,borderRight:'1px solid '+C('bord'),display:'flex',alignItems:'center',wordBreak:'break-word'}}>{f}</div>
                          {items.map((p,pi)=>(
                            <div key={pi} style={{flex:1,padding:'9px 12px',display:'flex',alignItems:'center',justifyContent:'center',borderRight:pi<items.length-1?'1px solid '+C('bord'):'none'}}>
                              {p.features.includes(f)
                                ? <span style={{color:'#4ECDC4',fontSize:15,lineHeight:1}}>✓</span>
                                : <span style={{color:'rgba(255,255,255,0.12)',fontSize:14,lineHeight:1}}>—</span>}
                            </div>
                          ))}
                          {items.length<3&&<div style={{flex:1}}/>}
                        </div>
                      ))}
                    </div>
                  </div>
                );
              })()}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
